import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from '.';

export type TemplateTimelineProps = TemplateProps;
export type TemplateTimelineXinglet = XingletInterface<TemplateTimelineProps>;

export const Timeline = XingletWrapper<TemplateTimelineProps>(
  `@xing-com/crate-lebenslauf-templates-timeline`
);
